var utils = require('./utils.js').default;
var get = require('./methodsHandler.js').default;
export default function (event, life, watch, methodsSource) {
    var E, L, W;
    var component = this;
    /**
     * 调用同目录下 methods.js 里的方法
     * @param name 方法名
     * @param param 其他参数
     * @returns {*}
     */
    var methods = function (name) {
        var param = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            param[_i - 1] = arguments[_i];
        }
        var func = methodsSource[name] || methodsSource.prototype[name]; // 目标函数，methodsSource可能是字面量对象，也可以是类
        if (!func)
            throw new Error('找不到 methods：' + name);
        // 限制了数据权限的vue实例
        var context = window.Proxy ? new Proxy(component, {
            get: get.bind(component, func.allowPath)
        }) : component;
        return func.apply(context, param);
    };
    var eventContext;
    if (window.noProxy) {
        component.methods = methods;
        eventContext = component;
    }
    else {
        eventContext = new Proxy(component, {
            get: function (target, name) {
                if (target === component && name === 'methods') {
                    return methods;
                }
                if (target === component) {
                    if (name === '_data') {
                        return utils.readOnlyProxy(target);
                    }
                    if (component._computedWatchers[name] // 开发者试图访问带 input或 output 的Model
                        || component.$data.hasOwnProperty(name) // 开发者试图访问其他 Model)
                        || (component.$props && component.$props.hasOwnProperty(name)) // 开发者试图访问其他 Model)
                    ) {
                        return utils.readOnlyProxy(component[name], 'event中不允许修改model');
                    }
                }
                return target[name];
            }
        });
    }
    E = changeEventContext.call(this, event, eventContext);
    L = changeEventContext.call(this, life, eventContext);
    W = changeEventContext.call(this, watch, eventContext);
    return { E: E, L: L, W: W };
}
function changeEventContext(event, eventContext) {
    var newEvent = {};
    event && Object.keys(event).forEach(function (key) {
        newEvent[key] = function () {
            var targetEvent;
            if (typeof event[key] === 'function') {
                targetEvent = event[key];
            }
            else if (event[key].handler) {
                targetEvent = event[key].handler;
            }
            return targetEvent.apply(eventContext, arguments);
        };
    });
    return newEvent;
}
